import type { EmailFieldType } from '@/src/Types/GF/Fields';

import Input from '../../components/Input';

type Props = {
	field: EmailFieldType;
	setFormValues: React.Dispatch<any>;
	formValues: any;
	errorMessage: string;
};

export default function EmailField({ field, setFormValues, formValues, errorMessage }: Props) {
	const { id, formId, type, label, description, cssClass, isRequired, placeholder } = field;
	const htmlId = `field_${formId}_${id}`;

	const updateValues = (value: any) => {
		const _form = { ...formValues };
		_form.values[`input_${id}`] = value;
		setFormValues(_form);
	};

	return (
		<div className={`gfield gfield-${type} ${cssClass}`.trim()}>
			<Input
				type={type}
				name={String(id)}
				id={htmlId}
				required={Boolean(isRequired)}
				placeholder={placeholder || label}
				onChange={(e) => updateValues(e.target.value)}
				htmlFor={htmlId}
				label={label}
				ariaLabel={label}
				description={description}
				errorMessage={errorMessage}
			/>
		</div>
	);
}
